// extracted by mini-css-extract-plugin
export var measureBox = "_41-0";